/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { BaseApi } from './BaseApi';
import { Observable } from 'rxjs/Observable';

export class DataShareApi extends BaseApi {
  endPoint: string = '/api/admin/data-share';

  public findInitiativeId(initiativeId: string): Observable<any> {
    return this.get(`${this.endPoint}/initiative/:initiativeId`, { initiativeId });
  }
}
